import React from "react";

import { colors } from "components";

import { BaseCard } from "components/BaseCard";
import { CircleIcon } from "components/CircleIcon";
import { CircularButton } from "components/CircularButton";
import { TitleSubTitleLabel } from "components/TitleSubTitleLabel";

import { IAttendantCardMconf } from "./interface.ts";
import {
  AttendantCardTopContainer,
  ButtonContainer,
  Container,
  ContainerIcon,
  IconArea,
  LeftContainer,
  RightContainer,
} from "./styles.ts";

export const AttendantCardMconf: React.FC<IAttendantCardMconf> = ({
  id,
  subTitle,
  title,
  selected,
  icon,
  onClickItem,
  onClickCopy,
  item,
  disabled,
  disabledCopy,
}) => {
  return (
    <>
      <AttendantCardTopContainer>
        <BaseCard
          selected={selected}
          onClick={onClickItem}
          height={50}
          data-testid={id}
          fixedBorder={true}
          disabled={disabled}
        >
          <Container>
            <LeftContainer>
              <ContainerIcon>
                <IconArea>
                  {icon === "avatar" ? (
                    <CircleIcon
                      icon={icon}
                      borderColor={colors.primary_default}
                      colorIcon={colors.general_icons}
                      backgroundColor="none"
                    />
                  ) : (
                    <CircleIcon
                      icon={icon}
                      borderColor={colors.secundary_default}
                      colorIcon={colors.secundary_default}
                      backgroundColor="none"
                    />
                  )}
                </IconArea>
              </ContainerIcon>
              <TitleSubTitleLabel
                childrenTitle={title}
                childrenSubTitle={subTitle}
              />
            </LeftContainer>
            <RightContainer id="buttonsRight">
              <ButtonContainer>
                <CircularButton
                  icon="Mconfcopy"
                  data-testid="copy-button"
                  onClick={() =>
                    item && onClickCopy ? onClickCopy(item) : null
                  }
                  colorIcon={colors.neutral_white}
                  border={`2px solid ${colors.primary_default}`}
                  backgroundColor={colors.primary_default}
                  disabled={disabled || disabledCopy}
                />
              </ButtonContainer>
            </RightContainer>
          </Container>
        </BaseCard>
      </AttendantCardTopContainer>
    </>
  );
};
